<div class="modal-header">
    @if(!processing() && poolUser) {
      <h4 class="me-2 text-truncate">
        <fa-icon [icon]=faUserCircle></fa-icon> 
        <span>{{poolUser.getName()}} - transferperiode-acties</span>
      </h4>          
    }    
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
</div>

<div class="modal-body">      

    @if(alert){
      <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
    }

    @if(!processing()) {
      <!-- replacements-->
      @if(list && list.replacements.length > 0) {
        <div class="mt-3">
          <h2>
            vervangingen
          </h2>
          <table class="table">
            <tbody>
              @for(replacement of list.replacements; track replacement.getId()) {
              <tr>
                <td>
                  <app-team-name [team]="replacement.getPlayerIn().getTeam()" [fullName]="false"></app-team-name>
                </td>
                <td>
                  <app-lineicon [line]="replacement.getPlayerOut().getLine()"></app-lineicon>
                  <span>{{replacement.getPlayerOut().getPerson().getName()}}</span>
                </td>
                <td>
                  <fa-icon [icon]=faChevronRight></fa-icon>
                </td>
                <td>
                  <app-lineicon [line]="replacement.getPlayerIn().getLine()"></app-lineicon>
                  <span>{{replacement.getPlayerIn().getPerson().getName()}}</span>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      }
      <!-- transfers-->
      @if(list && list.transfers.length > 0) {
        <div class="mt-3">
          <h2>
            transfers
          </h2>
          <table class="table">
            <tbody>
              @for(transfer of list.transfers; track transfer.getId()) {
              <tr>
                <td class="text-nowrap">
                  <app-team-name [team]="transfer.getPlayerOut().getTeam()" [fullName]="false"></app-team-name>
                </td>
                <td>
                  <app-lineicon [line]="transfer.getPlayerOut().getLine()"></app-lineicon>
                  <span>{{transfer.getPlayerOut().getPerson().getName()}}</span>
                </td>
                <td>
                  <fa-icon [icon]=faChevronRight></fa-icon>
                </td>
                <td class="text-nowrap">
                  <app-team-name [team]="transfer.getPlayerIn().getTeam()" [fullName]="false"></app-team-name>
                </td>
                <td>
                  <app-lineicon [line]="transfer.getPlayerIn().getLine()"></app-lineicon>
                  <span>{{transfer.getPlayerIn().getPerson().getName()}}</span>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      }
      <!-- wissels-->
      @if(calcFormation && list && list.substitutions.length > 0){
        <div class="mt-3">
          <h2>
            wissels
          </h2>
          <table class="table">
            <tbody>
              @for(substitution of list.substitutions; track substitution.getId()) {
              <tr>
                <td>
                  <app-lineicon [line]="substitution.getLineNumberOut()"></app-lineicon>
                </td>
                <td class="text-nowrap">
                  <app-team-name [team]="getPlayerOut(calcFormation, substitution).getTeam()" [fullName]="false"></app-team-name>
                </td>
                <td>
                  <span class="text-break">{{getPlayerIn(calcFormation, substitution).getPerson().getName()}}</span>
                </td>
                <td>
                  <fa-icon [icon]=faChevronRight></fa-icon>
                </td>
                <td class="text-nowrap">
                  <app-team-name [team]="getPlayerIn(calcFormation, substitution).getTeam()" [fullName]="false"></app-team-name>
                </td>
                <td>
                  <span class="text-break">{{getPlayerOut(calcFormation, substitution).getPerson().getName()}}</span>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
  </div>
